module.exports = __webpack_public_path__ + "static/media/DSC04662.a1b07b65.JPG";